import {connect, useSelector} from "react-redux";

export const useTeamsDatachatGuard = (route=null) => {
    const bot_access_user = useSelector(state => state.users.bot_access_user)

    const teamsDatachatAccount = bot_access_user?.teamsDatachatUser;

    return !!teamsDatachatAccount;
}
